import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAppUserPathPrefix } from 'App/components/utils/providers/AppUserProvider';
import { NavReminderBadge } from './NavReminderBadge';
import { NavRemindersMenu } from './NavRemindersMenu';
import { useReminderCount } from './useReminderCount';
import { createAllRemindersUrl, createReminderUrl, getReminderContext } from './reminderUrls';

export const NavReminders: React.FC = () => {
  const location = useLocation();
  const userPrefix = useAppUserPathPrefix();
  const amount = useReminderCount();

  const reminderContext = React.useMemo(
    () => getReminderContext( location.pathname ),
    [ location.pathname ],
  );

  const allRemindersUrl = React.useMemo(
    () => createAllRemindersUrl( userPrefix, amount ),
    [ amount, userPrefix ],
  );

  const newReminderUrl = React.useMemo(
    () => createReminderUrl( userPrefix, reminderContext ),
    [ reminderContext, userPrefix ],
  );

  return (
    <Dropdown className="drp-help drp-reminders">
      <Dropdown.Toggle
        variant={ 'link' }
        id="dropdownReminders"
        className="position-relative"
      >
        <i className="material-icons material-icons-outlined align-vertical-middle">
          notifications
        </i>
        <NavReminderBadge amount={ amount } />
        <span className="material-icons reminders-arrow align-vertical-middle pl-0">
          keyboard_arrow_down
        </span>
      </Dropdown.Toggle>
      <NavRemindersMenu
        allRemindersUrl={ allRemindersUrl }
        createReminderUrl={ newReminderUrl }
      />
    </Dropdown>
  );
};
